var storageFlag = function(){
	if(typeof window.localStorage === "object"){
		try{
			localStorage.setItem("localStorageTest", 1);
			localStorage.removeItem("localStorageTest");
			return true;
		}catch(e){
			return false;
		}
	}else{
		return false;
	}
}(),
	cookieDomain = '.dangdang.com';
// 读取存储数据
function getStorage(key, cookie){
    if(key.trim()){
        var res = "",
			isCookie = cookie && cookie == "cookie" ? true : false;
        if(storageFlag && !isCookie){
            if(localStorage.length > 0){
                var i = 0;
                for(; i < localStorage.length; i++){
                    if(localStorage.getItem(key)){
                        res = decodeURIComponent(localStorage.getItem(key));
                    }
                }
            }
            return res;
        }else{
            res = document.cookie.match(new RegExp("(^| )" + key + "=([^;]*)(;|$)"));
            if (res != null){
                return unescape(res[2]);
            }
            return "";
        }
    }
    return "";
}
//判断是否登录
function is_login(){
	var prefix = 'MDD_';
	return (getStorage(prefix + 'sid', 'cookie') && getStorage(prefix + 'token', 'cookie')) !== '' ? true: false;
}

export {is_login}


// WEBPACK FOOTER //
// ./src/common/js/login.js